<template>
  <div>
    <CustomerParentBar />
    <headline :content="`${$t('customer.customer_information')} ` + getMarketName">
      <v-btn class="info mx-2" @click="isSeletePrintDialog = true; seleteContracts = []"
        :disabled="isLoading || isSaveing">
        <v-icon left>mdi-printer</v-icon>
        {{ $t('print_document') }}
      </v-btn>
      <v-text-field solo dense background-color="grey lighten-4" flat type="text" :placeholder="$t('search')" :label="$t('search')"
        prepend-inner-icon="mdi-magnify" v-model="searchText" clearable color hide-details></v-text-field>
    </headline>
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div style="font-size: 1rem">
          <v-data-table
            :headers="dataTable.headers"
            :items="dataTable.data"
            item-key="objectId"
            :loading="isLoading"
            :search="searchText"
            class="border-2 dataTable row-pointer data-table-customer"
            :items-per-page="50"
            :no-data-text="$t('noinfo')"
            :no-results-text="$t('no_matching_records_found')">
            <template v-slot:item.contractLabel="{ item }">
              <div>
                <template v-for="contract in item.contracts.filter(cc => cc.isActive)">
                  <template v-if="contract.contractId">
                    <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50">
                      {{ contract.contractId }}
                      <span class="mx-1 text-xs" v-if="contract.stallType">
                        ({{ contract.stallType ? $t(`contact.stall_type.${contract.stallType}`) : '-' }})
                      </span>
                    </span>
                  </template>
                </template>
              </div>
            </template>


            <template v-slot:header.companyName="{header}">
              <div class="text-nowrap-table text-center" style="min-width:190px">{{header.text}}</div>
            </template>
            <template v-slot:header.fullName="{header}">
              <div class="text-nowrap-table text-center" style="min-width:190px;">{{header.text}}</div>
            </template>

            <template v-slot:item.companyName="{ item }">
              <div class="text-truncate business-name text-start">
                {{ item.companyName }}
              </div>
            </template>
            <template v-slot:item.fullName="{ item }">
              <div class="text-truncate customer-name text-start">
                {{ item.type == "company" ? "-" : item.fullName }}
              </div>
            </template>
            <template v-slot:item.emails="{ item }">
              <div style="max-width: 300px">
                <template v-for="email in item.emails">
                  <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50">{{ email || "-" }}</span>
                </template>
              </div>
            </template>
            <template v-slot:item.tels="{ item }">
              <div style="max-width: 300px">
                <template v-if="item.interTels.filter(tel => tel && tel != '-').length">
                  <template v-for="tel in item.interTels">
                    <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50">{{ $helper.telToString([tel]) || "-" }}</span>
                  </template>
                </template>
                <template v-else>
                  <template v-for="tel in item.tels">
                    <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50">{{ $helper.telToString([tel]) || "-" }}</span>
                  </template>
                </template>
              </div>
            </template>
            <template v-slot:item.view="{ item }">
              <a :href="`${item.objectId}/view`" target="_blank">
                <v-btn color="primary" text>
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </a>
            </template>
          </v-data-table>
        </div>
      </template>
    </layout>
    <v-dialog v-model="isSeletePrintDialog" max-width="1300" persistent scrollable>
      <v-card flat outlined :loading="isLoading" min-height="30">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="d-flex justify-space-between" style="width: 100%">
            <span>{{$t('print_document')}}</span>
            <v-btn color="black" icon @click="isSeletePrintDialog = false;">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <div class="d-flex justify-end align-center m-2 px-2">
          <v-btn class="mx-2" color="info" style="margin-left:10px;" @click="print()" :disabled="isLoading || isSaveing">
            <v-icon left>mdi-printer</v-icon>
            {{$t('print')}}
          </v-btn>
          <span style="width: 300px;">
            <v-text-field style="padding-top: 2px;" solo dense background-color="grey lighten-4" flat type="text"
              :placeholder="$t('search')" :label="$t('search')" prepend-inner-icon="mdi-magnify" v-model="searchPrintContract" clearable
              color hide-details></v-text-field>
          </span>
        </div>
        <v-card-text style="padding:0;">
          <v-data-table
            :loading="isLoading || isSaveing"
            :headers="headers"
            v-model="seleteContracts"
            :items-per-page="50"
            :items="contracts"
            class="border-2"
            sort-by="contractId"
            item-key="objectId"
            :show-select="true"
            :search="searchPrintContract"
            :no-data-text="$t('noinfo')"
            :no-results-text="$t('no_matching_records_found')">
            <template v-slot:item.customer="{ item }">{{ item.customer.fullName }}</template>
            <template v-slot:item.areas="{ item }">{{ item.areas.map(d => d.name).join(",") }}</template>
            <template v-slot:item.stallType="{ item }">{{ item.stallType == "temporary" ? $t('contact.stall_type.temporary') : $t('contact.stall_type.regularly')
            }}</template>
            <template v-slot:item.startDate="{ item }">{{ item.startDate && item.startDate.iso ?
              $moment(item.startDate.iso).format("DD/MM/YYYY") : "" }}</template>
            <template v-slot:item.endDate="{ item }">{{ item.endDate && item.endDate.iso ?
              $moment(item.endDate.iso).format("DD/MM/YYYY") : "" }}</template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isDocumentEditorDialog" fullscreen class="editor-dialog">
      <DocumentEditorDialog v-if="isDocumentEditorDialog && templateData" type="preview" :title="templateData.title"
        :layout="templateData.layout" :paperSetting="templateData.paperSetting"
        @onClose="isDocumentEditorDialog = false" />
    </v-dialog>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
  </div>
</template>

<script>
import CustomerMenu from "../../components/CustomerMenu";
import MarketCustomers from "../../components/MarketCustomers.component.vue";
import { mapGetters, mapState } from "vuex";
import Headline from "../../components/Headline";
import ParentBar from "../../components/ParentBar";
import CustomerParentBar from "../../components/CustomerParentBar.component.vue";
import Layout from "../../components/Layout";
import DocumentEditorDialog from "../../components/DocumentEditorDialog.component";
export default {
  components: {
    CustomerMenu,
    MarketCustomers,
    Headline,
    ParentBar,
    CustomerParentBar,
    Layout,
    DocumentEditorDialog
  },
  name: "Customer",
  created() { },
  computed: {
    ...mapGetters({
      getProjectId: "markets/getProjectId",
      getMarketName: "markets/getMarketName",
      // customer: "customer/getCustomers",
    }),
    ...mapState({
      customers: (state) => state.customer.customers,
    }),
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      isSuccess: false,
      isError: false,
      isLoading: false,
      searchText: "",
      dataTable: {
        headers: [
          { text: this.$t('bill.customer_market_id'), value: "customerMarketId" },
          { text: this.$t('contract.title'), value: "contractLabel" },
          { text: this.$t('customer.company_name_title'), value: "companyName",width: '1%',class : 'custom-sort', align: 'center hd-resize text-truncate' },
          // { text: "คำนำหน้า", value: "title" },
          { text: this.$t('market.marchant_name'), value: "fullName",width: '1%',class : 'custom-sort', align: 'center hd-resize text-truncate'},
          { text: this.$t('account.email_address'), value: "emails" },
          { text: this.$t('account.phone_number'), value: "tels" },
          // { text: "การจัดการ", value: "objectId" },
          { text: "", value: "view" },
        ],
      },
      contracts: [],
      seleteContracts: [],
      isSeletePrintDialog: false,
      isDocumentEditorDialog: false,
      templateData: null,
      isSaveing: false,
      searchPrintContract: "",
      headers: [
        {
          value: "contractId",
          text: this.$t('contract.contract_number_only')
        },
        {
          value: "customer",
          text: this.$t('contract.contract_owner_name')
        },
        {
          value: "areas",
          text: this.$t('area.space')
        },
        {
          value: "stallType",
          text: this.$t('area.stall_type')
        },
        {
          value: "startDate",
          text: this.$t('start_date')
        },
        {
          value: "endDate",
          text: this.$t('end_date')
        }
      ],
    };
  },
  created() {
    this.initData();
  },
  watch: {
    customers() {
      this.dataTable.data = this.customers?.map((customer) => {
        let contract = customer.contracts.filter(cc => cc.isActive)
          .find((x) => x.market && (x.market.objectId == this.marketId) && x.isActive);
        customer.customerMarketId = contract.customerMarketId || ""
        customer.erpId = customer.erpId || "-";
        customer.contractLabel = customer.contracts.filter(cc => cc.isActive)
          .map((i) => i.contractId)
          .join(",");
        customer.businessName = customer.businessName || "-";
        customer.emails = customer.emails.length > 0 ? customer.emails : ["-"];
        customer.tels = customer.tels.length > 0 ? customer.tels : ["-"];
        // customer.fullName = customer.firstName ? customer.firstName + " " + customer.lastName : "-";
        return customer;
      })
    },
  },
  methods: {
    async initData() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("markets/getMarketArea", { id: this.marketId });
        await this.$store.dispatch("customer/getCustomers");
        for (let customer of this.customers) {
          if (customer.contracts && customer.contracts.length) {
            for (let contract of customer.contracts) {
              if (contract.isActive && contract?.market?.objectId == this.marketId) this.contracts.push({ ...contract, customer: customer })
            }
          }
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error)
        this.isLoading = false;
        this.isError = true;
      }
    },
    async print() {
      this.isSaveing = true
      try {
        let contractDocuments = await this.$store.dispatch("contractDocument/getContractDocumentByContractIds", {
          contractIds: this.seleteContracts.map(d => d.objectId)
        });

        let contractIds = []
        this.templateData = {
          layout: []
        }

        for (let contractDocument of contractDocuments) {
          if (contractDocument.templates && contractDocument.templates.length) {
            contractIds.push(contractDocument.contract.objectId)
            for (let template of contractDocument.templates) {
              if (!this.templateData.title) this.templateData.title = template.title
              if (!this.templateData.paperSetting) this.templateData.paperSetting = template.paperSetting
              if (template.layout && template.layout.length) {
                for (let layout of template.layout) {
                  this.templateData.layout.push(layout)
                }
              }
            }
          }
        }
        this.isDocumentEditorDialog = true
        this.isSaveing = false
      } catch (err) {
        console.log(err)
        this.isError = true
        this.isSaveing = false
      }

    }
  },
};
</script>

<style lang="scss" scoped>

.data-table-customer::v-deep td.hd-resize{
  max-width: 190px;
}

.data-table-customer::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 30px;
    top: 15px;
  }
}

// .text-start {
//   border-right: 1px solid #eee;
// }

.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: center !important;
}

.v-data-table::v-deep td {
  font-size: 1rem !important;
  text-align: center !important;
  padding-right: 2rem !important;
  max-width: 250px;
}

.row-cursor tbody tr:hover {
  cursor: pointer;
}

.text-nowrap-table.business-name,
.text-nowrap-table.customer-name {
  width: 100%;
  text-align: center;
}
</style>
